module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', [(!_vm.paly_show) ? _c('img', {
    staticClass: "course—pic",
    attrs: {
      "src": _vm.row.pic_url,
      "alt": ""
    }
  }) : _c('video', {
    ref: "videos",
    attrs: {
      "width": "100%",
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "id": "playVideosss",
      "src": _vm.play_url
    }
  })])]), _vm._v(" "), _c('van-tabs', {
    staticClass: "active-tab",
    attrs: {
      "animated": "",
      "sticky": "",
      "title-active-color": "#000"
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, _vm._l((_vm.activeTab), function(item, index) {
    return _c('van-tab', {
      key: index,
      scopedSlots: _vm._u([{
        key: "title",
        fn: function() {
          return [_vm._v("\n        " + _vm._s(item.name) + "\n      ")]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), (_vm.active == 0) ? _c('div', {
      staticClass: "directory"
    }, [_c('van-steps', {
      attrs: {
        "direction": "vertical",
        "active": _vm.videoActive,
        "active-icon": "checked",
        "inactive-icon": "circle"
      }
    }, _vm._l((_vm.row.items), function(item, i) {
      return _c('van-step', {
        key: i
      }, [_c('p', {
        staticClass: "course-title",
        on: {
          "click": function($event) {
            return _vm.onPlayItems(i)
          }
        }
      }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
        staticClass: "course-info",
        on: {
          "click": function($event) {
            return _vm.onPlayItems(i)
          }
        }
      }, [_vm._v(_vm._s(item.views_count) + "人播放")])])
    }), 1), _vm._v(" "), (_vm.row.items.length == 0) ? _c('div', [_c('van-empty', {
      attrs: {
        "description": "暂时还没上传视频!"
      }
    })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.active == 1) ? _c('div', {
      staticClass: "course-detail"
    }, [_c('div', {
      staticClass: "course-title-box"
    }, [_c('div', {
      staticClass: "course-detail-title"
    }, [_vm._v(_vm._s(_vm.row.title))]), _vm._v(" "), (_vm.row.need_pay == '1') ? _c('div', {
      staticClass: "course-detail-info"
    }, [_vm._v("免费")]) : _c('div', {
      staticClass: "course-detail-info"
    }, [_c('span', {
      staticClass: "course-price"
    }, [_vm._v("¥" + _vm._s(_vm.row.price))]), _vm._v(" "), _c('span', {
      staticClass: "course-validity"
    }, [_vm._v("有效期 " + _vm._s(_vm.row.pay_days) + "天")])]), _vm._v(" "), _c('div', {
      staticClass: "course-play"
    }, [_c('span', {
      staticClass: "course-num"
    }, [_vm._v("视频 " + _vm._s(_vm.row.items.length))]), _vm._v(" "), _c('span', {
      staticClass: "course-play-num"
    }, [_vm._v("播放" + _vm._s(_vm.row.views_count))])])]), _vm._v(" "), _c('div', {
      staticClass: "course-content"
    }, [_c('div', {
      staticClass: "course-content-title"
    }, [_vm._v("课程介绍")]), _vm._v(" "), _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(_vm.row.content)
      }
    })])]) : _vm._e()])
  }), 1), _vm._v(" "), (_vm.row.need_pay == '2') ? _c('div', {
    staticClass: "course-bottom"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "padding": "0 10px",
      "height": "62px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "bottom-course"
  }, [_vm._v("课程")]), _vm._v(" "), _c('span', {
    staticClass: "bottom-course-price"
  }, [_vm._v("¥" + _vm._s(_vm.row.price))])]), _vm._v(" "), _c('div', {
    staticClass: "course-pay",
    on: {
      "click": _vm.onPlayShwo
    }
  }, [_vm._v("立即购买")])])]) : _vm._e(), _vm._v(" "), _c('van-overlay', {
    attrs: {
      "show": _vm.pay_show
    },
    on: {
      "click": function($event) {
        _vm.pay_show = false
      }
    }
  }, [_c('div', {
    staticClass: "wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticStyle: {
      "flex": "1",
      "display": "flex",
      "justify-content": "center",
      "flex-direction": "column"
    }
  }, [_c('p', [_vm._v("本视频需要付费开通")]), _vm._v(" "), _c('p', [_vm._v("您可以选择在线支付或者使用激活卡")])]), _vm._v(" "), _c('div', {
    staticClass: "pay-show-bottom"
  }, [_c('span', {
    staticClass: "no-pay",
    on: {
      "click": function($event) {
        _vm.pay_show = false
      }
    }
  }, [_vm._v("不看了")]), _vm._v(" "), _c('span', {
    staticClass: "on-pay",
    on: {
      "click": _vm.onPlayShwo
    }
  }, [_vm._v("立即开通")])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c3842c7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/course/CourseDetail.vue
// module id = 1536
// module chunks = 0